import { createContext, useContext } from 'react';

import { isLogsReadOnly, LogsMode } from './logsMode';

// По умолчанию legacy: страницы без провайдера работают как раньше
const LogsModeContext = createContext<LogsMode>(LogsMode.legacy);

export const LogsModeProvider = LogsModeContext.Provider;

export const useLogsMode = () => useContext(LogsModeContext);

export const useIsLogsReadOnly = () => isLogsReadOnly(useLogsMode());
